export default {
  name: "CloseCircleSolid",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M16 2C8.28 2 2 8.28 2 16s6.28 14 14 14 14-6.28 14-14S23.72 2 16 2zm5.56 17.44a1.5 1.5 0 0 1-2.12 2.12L16 18.12l-3.44 3.44a1.5 1.5 0 0 1-2.12-2.12L13.88 16l-3.44-3.44a1.5 1.5 0 0 1 0-2.12 1.5 1.5 0 0 1 2.12 0L16 13.88l3.44-3.44a1.5 1.5 0 0 1 2.12 0 1.5 1.5 0 0 1 0 2.12L18.12 16l3.44 3.44z",
  },
}
